import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import ArSummaryMobile from './ArSummaryMobile';
import { contentSel } from 'src/store/modules/arSummary';

const mapStateToProps = (state: any) => {
  return {
    ArSummaryContent: contentSel(state)
  };
};

export const pureComponent = ArSummaryMobile;
export default connect(mapStateToProps)(withI18n()(ArSummaryMobile));
